import { render } from "./BookingInvoiceDetails.vue?vue&type=template&id=6060da7e"
import script from "./BookingInvoiceDetails.vue?vue&type=script&lang=js"
export * from "./BookingInvoiceDetails.vue?vue&type=script&lang=js"

import exportComponent from "/home/runner/work/abdom-clean-homes-booking/abdom-clean-homes-booking/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__